import type { RootState } from '@/store';

export const selectEnviosAr = (state: RootState) => state.autorizacaoAr.envios;

/**
 * Contadores do PROCESSO inteiro, vindos do servidor.
 *
 * Derivá-los de `envios` contaria só o que a página trouxe e usaria régua própria — o
 * servidor conta `vencidas` pelo dia civil de São Paulo, que o navegador não sabe
 * reproduzir sem repetir a armadilha de fuso.
 */
export const selectResumoAr = (state: RootState) => state.autorizacaoAr.resumo;

/**
 * `solicitacaoId` → `requestId` da decisão em voo. O card desabilita o botão DAQUELA
 * solicitação; travar as outras por causa de uma seria punir o requerido vizinho.
 */
export const selectAcaoEmVooAr = (state: RootState) => state.autorizacaoAr.acaoEmVoo;

export const selectErroAr = (state: RootState) => state.autorizacaoAr.error;

/** Só o polling lê este — a falha de leitura não vira erro na tela (ver o slice). */
export const selectErroLeituraAr = (state: RootState) => state.autorizacaoAr.erroLeitura;
